import { DropdownMenuItem, FAIcon } from '@/components'
import { InfringementActions } from '@/modules/infringements/components/infringement-follow-up'
import { useFollowUpStateMutations } from '@/modules/infringements/components/use-follow-up-state'
import { useTranslate } from '@ur-solutions/react-hooks'
import type { ResultOf } from 'gql.tada'
import React from 'react'
import type { WORK_DAY_INFRINGEMENT_QUERY } from '../queries'

type WorkDayInfringementNode = NonNullable<
  ResultOf<typeof WORK_DAY_INFRINGEMENT_QUERY>['workDayInfringement']
>

interface Props {
  infringement: WorkDayInfringementNode
  canMarkWronglyGenerated: boolean
  wronglyGeneratedLoading: boolean
  onToggleWronglyGenerated(): void
}

/** The work day infringement page's header actions. */
export const WorkDayActions: React.FC<Props> = ({
  infringement,
  canMarkWronglyGenerated,
  wronglyGeneratedLoading,
  onToggleWronglyGenerated,
}) => {
  const translations = useTranslate({
    markWronglyGenerated: 'infringements.mark-wrongly-generated',
    unmarkWronglyGenerated: 'infringements.unmark-wrongly-generated',
  })
  const state = useFollowUpStateMutations()

  return (
    <InfringementActions
      closed={!!infringement.closedAt}
      archived={!!infringement.archivedAt}
      busy={state.loading || wronglyGeneratedLoading}
      onSetClosed={closed =>
        state.setClosed('WORKING_TIME', infringement.id, closed)
      }
      onSetArchived={(archived, basis) =>
        state.setArchived('WORKING_TIME', infringement.id, archived, basis)
      }
      menuItems={
        canMarkWronglyGenerated && (
          <DropdownMenuItem onClick={onToggleWronglyGenerated}>
            <FAIcon icon="flag" fixedWidth />
            {infringement.wronglyGenerated
              ? translations.unmarkWronglyGenerated
              : translations.markWronglyGenerated}
          </DropdownMenuItem>
        )
      }
    />
  )
}
